
import { defineComponent } from 'vue';
import MainFooter from './components/organisms/MainFooter.vue';

export default defineComponent({
  components: { MainFooter },
});
